import Vue from 'vue'
import VueRouter from 'vue-router'

const index = () => import( /* webpackChunkName: "login_home_welcome" */ '../views/News/index.vue')

const News = () => import( /* webpackChunkName: "login_home_welcome" */ '../views/News/News.vue')

const Home = () => import( /* webpackChunkName: "login_home_welcome" */ '../components/Home.vue')

const refresh = () => import( /* webpackChunkName: "login_home_welcome" */ '../views/refresh.vue')

const About = () => import( /* webpackChunkName: "login_home_welcome" */ '../views/About.vue')

const spInformation = () => import( /* webpackChunkName: "login_home_welcome" */ '../views/spInformation.vue')

const certificate = () => import( /* webpackChunkName: "login_home_welcome" */ '../views/certificate.vue')

const smartmedical = () => import( /* webpackChunkName: "login_home_welcome" */ '../views/smartmedical.vue')

const course = () => import( /* webpackChunkName: "login_home_welcome" */ '../views/course.vue')



Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    component: Home,
    children: [{
        path: '/index',
        component: index
      },
      {
        path: '/News',
        component: News
      },
      {
        path: '/refresh',
        component: refresh
      },
      {
        path: '/About',
        component: About
      },
      {
        path: '/spInformation',
        component: spInformation
      },
      {
        path: '/certificate',
        component: certificate
      },
      {
        path: '/smartmedical',
        component: smartmedical
      },
      {
        path: '/course',
        component: course
      }
    ]
  }
]

const router = new VueRouter({
  routes
})
export default router
